"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Datav3Controller", {
    enumerable: true,
    get: function() {
        return Datav3Controller;
    }
});
const _common = require("@nestjs/common");
const _express = require("express");
const _nocodbsdk = require("nocodb-sdk");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _helpers = require("~/helpers");
const _dataapilimiterguard = require("~/guards/data-api-limiter.guard");
const _globalguard = require("~/guards/global/global.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _datav3service = require("~/services/v3/data-v3.service");
const _datatableservice = require("~/services/data-table.service");
const _dataattachmentv3service = require("~/services/v3/data-attachment-v3.service");
const _controllers = require("~/constants/controllers");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let Datav3Controller = class Datav3Controller {
    async dataList(context, req, res, baseName, modelId, viewId) {
        context.cache = true;
        const startTime = process.hrtime();
        const responseData = await this.dataV3Service.dataList(context, {
            query: req.query,
            modelId: modelId,
            viewId: viewId,
            req
        });
        const elapsedSeconds = (0, _helpers.parseHrtimeToMilliSeconds)(process.hrtime(startTime));
        res.setHeader('xc-db-response', elapsedSeconds);
        res.json(responseData);
    }
    async dataInsert(context, req, baseName, modelId, viewId, body) {
        context.cache = true;
        return await this.dataV3Service.dataInsert(context, {
            modelId: modelId,
            body: body,
            viewId,
            cookie: req
        });
    }
    async dataAttachmentUpload(context, req, modelId, recordId, columnId, body) {
        context.cache = true;
        return await this.dataAttachmentV3Service.appendBase64AttachmentToCellData({
            context,
            modelId,
            recordId,
            columnId,
            scope: undefined,
            attachment: body,
            req
        });
    }
    async dataDelete(context, req, baseName, modelId, viewId, body, records) {
        context.cache = true;
        return await this.dataV3Service.dataDelete(context, {
            modelId: modelId,
            cookie: req,
            viewId,
            body,
            queryRecords: records
        });
    }
    async dataUpdate(context, req, baseName, modelId, viewId, body) {
        context.cache = true;
        return await this.dataV3Service.dataUpdate(context, {
            modelId: modelId,
            body: body,
            cookie: req,
            viewId
        });
    }
    async nestedDataList(context, req, baseName, modelId, viewId, columnId, rowId) {
        context.cache = true;
        return await this.dataV3Service.nestedDataList(context, {
            modelId,
            rowId: rowId,
            query: req.query,
            viewId,
            columnId,
            req
        });
    }
    async nestedLink(context, req, baseName, modelId, viewId, columnId, rowId, refRowIds) {
        context.cache = true;
        return await this.dataV3Service.nestedLink(context, {
            modelId,
            rowId: rowId,
            query: req.query,
            viewId,
            columnId,
            refRowIds,
            cookie: req
        });
    }
    async nestedUnlink(context, req, baseName, modelId, viewId, columnId, rowId, refRowIds) {
        context.cache = true;
        return await this.dataV3Service.nestedUnlink(context, {
            modelId,
            rowId: rowId,
            query: req.query,
            viewId,
            columnId,
            refRowIds,
            cookie: req
        });
    }
    async dataCount(context, req, res, baseName, modelId, viewId) {
        context.cache = true;
        const countResult = await this.dataTableService.dataCount(context, {
            query: req.query,
            modelId,
            viewId,
            apiVersion: _nocodbsdk.NcApiVersion.V3
        });
        res.json(countResult);
    }
    async dataRead(context, req, baseName, modelId, viewId, rowId) {
        context.cache = true;
        return await this.dataV3Service.dataRead(context, {
            modelId,
            rowId: rowId,
            query: req.query,
            viewId,
            req
        });
    }
    constructor(dataV3Service, dataTableService, dataAttachmentV3Service){
        this.dataV3Service = dataV3Service;
        this.dataTableService = dataTableService;
        this.dataAttachmentV3Service = dataAttachmentV3Service;
    }
};
_ts_decorate([
    (0, _common.Get)(`${_controllers.PREFIX_APIV3_DATA}/:modelId/records`),
    (0, _extractidsmiddleware.Acl)('dataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Res)()),
    _ts_param(3, (0, _common.Param)('baseName')),
    _ts_param(4, (0, _common.Param)('modelId')),
    _ts_param(5, (0, _common.Query)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], Datav3Controller.prototype, "dataList", null);
_ts_decorate([
    (0, _common.Post)(`${_controllers.PREFIX_APIV3_DATA}/:modelId/records`),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('dataInsert'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('modelId')),
    _ts_param(4, (0, _common.Query)('view_id')),
    _ts_param(5, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], Datav3Controller.prototype, "dataInsert", null);
_ts_decorate([
    (0, _common.Post)(`${_controllers.PREFIX_APIV3_DATA}/:modelId/records/:recordId/fields/:columnId/upload`),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('dataUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Param)('recordId')),
    _ts_param(4, (0, _common.Param)('columnId')),
    _ts_param(5, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], Datav3Controller.prototype, "dataAttachmentUpload", null);
_ts_decorate([
    (0, _common.Delete)(`${_controllers.PREFIX_APIV3_DATA}/:modelId/records`),
    (0, _extractidsmiddleware.Acl)('dataDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('modelId')),
    _ts_param(4, (0, _common.Query)('view_id')),
    _ts_param(5, (0, _common.Body)()),
    _ts_param(6, (0, _common.Query)('records')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        Object,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], Datav3Controller.prototype, "dataDelete", null);
_ts_decorate([
    (0, _common.Patch)(`${_controllers.PREFIX_APIV3_DATA}/:modelId/records`),
    (0, _extractidsmiddleware.Acl)('dataUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('modelId')),
    _ts_param(4, (0, _common.Query)('view_id')),
    _ts_param(5, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], Datav3Controller.prototype, "dataUpdate", null);
_ts_decorate([
    (0, _common.Get)(`${_controllers.PREFIX_APIV3_DATA}/:modelId/links/:columnId/:rowId`),
    (0, _extractidsmiddleware.Acl)('nestedDataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('modelId')),
    _ts_param(4, (0, _common.Query)('viewId')),
    _ts_param(5, (0, _common.Param)('columnId')),
    _ts_param(6, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], Datav3Controller.prototype, "nestedDataList", null);
_ts_decorate([
    (0, _common.Post)(`${_controllers.PREFIX_APIV3_DATA}/:modelId/links/:columnId/:rowId`),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('nestedDataLink'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('modelId')),
    _ts_param(4, (0, _common.Query)('view_id')),
    _ts_param(5, (0, _common.Param)('columnId')),
    _ts_param(6, (0, _common.Param)('rowId')),
    _ts_param(7, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], Datav3Controller.prototype, "nestedLink", null);
_ts_decorate([
    (0, _common.Delete)(`${_controllers.PREFIX_APIV3_DATA}/:modelId/links/:columnId/:rowId`),
    (0, _extractidsmiddleware.Acl)('nestedDataUnlink'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('modelId')),
    _ts_param(4, (0, _common.Query)('view_id')),
    _ts_param(5, (0, _common.Param)('columnId')),
    _ts_param(6, (0, _common.Param)('rowId')),
    _ts_param(7, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], Datav3Controller.prototype, "nestedUnlink", null);
_ts_decorate([
    (0, _common.Get)(`${_controllers.PREFIX_APIV3_DATA}/:modelId/count`),
    (0, _extractidsmiddleware.Acl)('dataCount'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Res)()),
    _ts_param(3, (0, _common.Param)('baseName')),
    _ts_param(4, (0, _common.Param)('modelId')),
    _ts_param(5, (0, _common.Query)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], Datav3Controller.prototype, "dataCount", null);
_ts_decorate([
    (0, _common.Get)(`${_controllers.PREFIX_APIV3_DATA}/:modelId/records/:rowId`),
    (0, _extractidsmiddleware.Acl)('dataRead'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('modelId')),
    _ts_param(4, (0, _common.Query)('view_id')),
    _ts_param(5, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], Datav3Controller.prototype, "dataRead", null);
Datav3Controller = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_dataapilimiterguard.DataApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _datav3service.DataV3Service === "undefined" ? Object : _datav3service.DataV3Service,
        typeof _datatableservice.DataTableService === "undefined" ? Object : _datatableservice.DataTableService,
        typeof _dataattachmentv3service.DataAttachmentV3Service === "undefined" ? Object : _dataattachmentv3service.DataAttachmentV3Service
    ])
], Datav3Controller);
